var map = {
	"./1st-madle.png": "8780",
	"./2nd-madle-old.png": "b001",
	"./2nd-madle.png": "0de1",
	"./3rd-madle-old.png": "6cd1",
	"./3rd-madle.png": "b314",
	"./Camera.png": "3ca8",
	"./Course-Card-Done-Left.png": "8cbd",
	"./Course-Card-Done-Right.png": "429e",
	"./Courses-Card-Type-1.png": "1984",
	"./Courses-Card-Type-2.png": "7aa9",
	"./Courses-Card-Type-3.png": "5676",
	"./Courses-Card-Type-4.png": "87f1",
	"./FBISE.png": "1e41",
	"./Group 2874.png": "db54",
	"./Group 4041.png": "45c8",
	"./Group 8022.png": "5dae",
	"./Group 8023.png": "9fea",
	"./Group 91@2x.png": "6ed7",
	"./IMG_1037-2.png": "4a43",
	"./IMG_1037-2@2x.png": "0562",
	"./Icon - Keyboard Arrow - Up - Dark.png": "1b6c",
	"./Icon-Download Notes-enabled.png": "054d",
	"./Icon-DownloadNotes-disabled.png": "07af",
	"./achivement-img.png": "c689",
	"./arrow-upward.png": "409d",
	"./attempt-filter-dd-icon.png": "4d39",
	"./attempt-filter-icon.png": "219c",
	"./back.png": "336c",
	"./breadcrum-icon.png": "1f6a",
	"./calculator-icon-hover.png": "a83b",
	"./calculator-icon.png": "89e3",
	"./calendar.png": "2cc6",
	"./cancel_red.png": "1370",
	"./dashboard/card-el-7.png": "2d48",
	"./download-app.png": "e06b",
	"./dwn_red.png": "c9fa",
	"./dwn_white.png": "1030",
	"./linkedin icon.png": "af0e",
	"./live-chat/avatar.png": "cbb0",
	"./login/course-img-1.png": "fbb6",
	"./login/course-img.png": "704d",
	"./metro-camera.png": "6a64",
	"./noti-thumb-1.png": "ce2f",
	"./pakistan-map.png": "1bcd",
	"./pause-icon.png": "c280",
	"./play-button-vimeo.png": "43f0",
	"./play-cont.png": "b368",
	"./player-icons/Icon-rev-10s-hover.png": "68d9",
	"./player-icons/icon-rev-10s-def.png": "1bcc",
	"./player-icons/resize-back.png": "28ce",
	"./practice/profile-img.png": "51b8",
	"./region-icon.png": "1b93",
	"./scroll-down-icon.png": "01b1",
	"./single-image.png": "69c9",
	"./teenyicons_tick-solid.png": "b05d",
	"./trending-city-icon.png": "f81f",
	"./user-position/avard-bg.png": "a69b",
	"./user-position/avatar-bg-2nd.png": "53c9",
	"./user-position/avatar-bg-2nd1.png": "e4e5",
	"./user-position/avatar-bg-3rd.png": "6b57",
	"./user-position/avatar-bg-3rd1.png": "7f08",
	"./user-position/avatar.png": "4da4",
	"./user-position/clap-icon.png": "37f3",
	"./user-position/clock-icon.png": "c48b",
	"./user-position/facebook-icon.png": "d255",
	"./user-position/topPerfomersbg1.png": "83be",
	"./user-position/twitter-icon.png": "1eb3",
	"./user-position/whatsapp-icon.png": "654a",
	"./wireframes/cart-icon-hover.png": "58ae",
	"./wireframes/cart-icon.png": "395b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e019";